<app-spinner *ngIf="showSpinner"></app-spinner>

<mat-list #matchList [style.display]="showSpinner ? 'none' : 'block'">
  <mat-list-item *ngFor="let field of matchFieldsViewModel">
    <mat-form-field>
      <mat-select placeholder="swodoc" [(value)]="field.swodoc" (openedChange)="onOpenedChange(field, $event)">
        <div style="display: flex; align-items: center; padding: 4px">
          <input
            matInput
            type="text"
            placeholder="Felder filtern..."
            [(ngModel)]="searchTermSwodocMatch"
            (click)="$event.stopPropagation()"
            autocomplete="off"
            style="flex: 1; margin-right: 8px"
          />

          <button mat-icon-button (click)="deleteFilter()" (click)="$event.stopPropagation()">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <mat-option>- Keine -</mat-option>

        <mat-optgroup *ngFor="let section of templateNodes.sections" [label]="section.title">
          <mat-option
            *ngFor="let node of section.nodes | templateMatchFilter : searchTermSwodocMatch : field.isOpened"
            [value]="node._id"
            [disabled]="itemDisabled(node._id)"
          >
            {{ node.title }} <ng-container *ngIf="node.name">- {{ node.name }} </ng-container>
            <small style="color: lightgrey">({{ node.type }})</small>
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-select
        placeholder="alberta"
        [compareWith]="compareFn"
        [(value)]="field.alberta"
        (openedChange)="onOpenedChange(field, $event)"
      >
        <div style="display: flex; align-items: center; padding: 4px">
          <input
            matInput
            type="text"
            placeholder="Felder filtern..."
            [(ngModel)]="searchTermAlbertaMatch"
            (click)="$event.stopPropagation()"
            autocomplete="off"
            style="flex: 1; margin-right: 8px"
          />

          <button mat-icon-button (click)="deleteFilter()" (click)="$event.stopPropagation()">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <mat-option>- Keine -</mat-option>
        <mat-option
          *ngFor="let field of albertaMatchFields | templateMatchFilter : searchTermAlbertaMatch : field.isOpened"
          [value]="field"
        >
          {{ field.title }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-icon-button (click)="removeMatchField(field)">
      <mat-icon>delete</mat-icon>
    </button>
  </mat-list-item>
</mat-list>
<button mat-button (click)="addMatchField()" class="add-button" color="primary">
  <mat-icon>add</mat-icon>Zuordnung hinzufügen
</button>
